import { UserAction, userActionTypeEnum } from '@thoughtspot/metrics';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useAppContext } from '/@contexts/global-app-context';
import { useUpdateDisplayName } from '/@services/session/session-service';
import { useUpdateUserPreferences } from '/@services/user-admin/user-admin-service';
import { updateNumTimesDisplayNameDialogShown } from '../../user-preference/display-name/display-name.util';
import { UpdateDisplayNameContainerProps } from '../invite-users.interface';
import { UpdateDisplayNameDialog } from './update-display-name';

export const UpdateDisplayNameContainer = ({
    isUpdateDisplayNameModalOpen,
    setIsUpdateDisplayNameModalOpen,
    onUpdateCB,
    onDismissCB,
    origin,
}: UpdateDisplayNameContainerProps) => {
    const { sessionService, metricsService } = useAppContext();
    const { updateDisplayName, data, loading, error } = useUpdateDisplayName();
    const [updatedDisplayName, setUpdateDisplayName] = useState<string>('');
    const { updateUserPreferences } = useUpdateUserPreferences();

    metricsService.collectEvent(
        new UserAction(userActionTypeEnum.UPDATE_DISPLAY_NAME_LOAD),
        { origin },
    );

    const onSave = (displayName: string) => {
        updateDisplayName(displayName);
        setUpdateDisplayName(displayName);
        metricsService.collectEvent(
            new UserAction(userActionTypeEnum.UPDATE_DISPLAY_NAME_SAVE),
            {},
        );
    };

    useEffect(() => {
        if (data) {
            setIsUpdateDisplayNameModalOpen(false);
            sessionService.setUserDisplayName(updatedDisplayName);
            updateNumTimesDisplayNameDialogShown();
            onUpdateCB();
        }
    }, [data]);

    const onDismiss = () => {
        const numTimesDialogShown = sessionService.getNumTimesDisplayNameDialogShown();
        sessionService.setNumTimesDisplayNameDialogShown(
            numTimesDialogShown + 1,
        );
        updateUserPreferences(
            sessionService.getUserGuid(),
            JSON.stringify(sessionService.getExposedUserPreferences()),
        );
        setIsUpdateDisplayNameModalOpen(false);
        metricsService.collectEvent(
            new UserAction(userActionTypeEnum.UPDATE_DISPLAY_NAME_CANCEL),
            {},
        );
        onDismissCB();
    };

    return (
        <UpdateDisplayNameDialog
            updateDisplayName={onSave}
            updateDisplayNameError={error}
            isModalOpen={isUpdateDisplayNameModalOpen}
            isUpdateInProgress={loading}
            onDismissCB={onDismiss}
            originalDisplayName={sessionService.getUserDisplayName()}
            origin={origin}
        />
    );
};
